<div class="drill" data-testid="drill-dialog">
  <header class="drill__head">
    <h2 class="drill__title" data-testid="drill-title">{{ data.title }}</h2>
    <button type="button" class="drill__close" data-testid="drill-close" aria-label="Close" (click)="close()">
      <i class="fa-regular fa-xmark" aria-hidden="true"></i>
    </button>
  </header>
  <div class="drill__body">
    <p *ngIf="loading" data-testid="drill-loading" class="drill__state">Loading…</p>
    <p *ngIf="failed" data-testid="drill-error" class="drill__state drill__state--error">Could not load this list.</p>
    <ng-container *ngIf="view">
      <p *ngIf="view.subtitle" data-testid="drill-subtitle" class="drill__subtitle">{{ view.subtitle }}</p>
      <app-admin-dashboard-empty *ngIf="!view.rows.length" icon="fa-regular fa-magnifying-glass" title="No companies here"
                                 body="Nothing in the current filters falls into this group." [compact]="true"></app-admin-dashboard-empty>
      <table *ngIf="view.rows.length" data-testid="drill-table" class="drill__table">
        <thead>
          <tr>
            <th class="drill__th">Company</th>
            <th *ngFor="let column of columns" class="drill__th" [class.drill__th--end]="column.align !== 'start'">{{ column.header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of view.rows" data-testid="drill-row" class="drill__row">
            <td class="drill__company">
              <button type="button" data-testid="drill-company" class="drill__name" (click)="openCompany(row)">{{ row.companyName }}</button>
              <div class="drill__meta"><span data-testid="drill-meta">{{ row.meta }}</span> · <button type="button" data-testid="drill-evidence" class="drill__evidence" (click)="evidence(row)">Evidence</button></div>
            </td>
            <td *ngFor="let cell of row.cells; let i = index" data-testid="drill-cell" class="drill__cell"
                [class.drill__cell--start]="alignOf(i) === 'start'">
              <span *ngIf="cell.pill" class="drill__pill" [ngClass]="'drill__pill--' + (cell.tone ?? 'neutral')">{{ cell.text }}</span>
              <span *ngIf="!cell.pill" class="drill__text" [ngClass]="cell.tone ? 'drill__text--' + cell.tone : ''">{{ cell.text }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="moreText" data-testid="drill-more" class="drill__more">{{ moreText }}</p>
    </ng-container>
  </div>
</div>
